export default __webpack_public_path__ + "static/media/Group 3204.b506fbbb.jpg";